// src/data/posts.js
// Single source of truth for all blog post metadata.
// Add new posts here. The homepage and category pages both import from this file.

const posts = [
  {
    slug: "quantization-in-llms",
    category: "tech",
    categoryLabel: "Tech",
    title: "Understanding Quantization in Large Language Models",
    date: "15 Nov 2025",
    description:
      "To reduce the size of an LLM, you can either simplify the architecture or reduce the precision of the weights. But quantization is not as simple as rounding off weights.",
  },
  {
    slug: "indian-soldiers-at-thermopylae",
    category: "today-i-learned",
    categoryLabel: "Today I Learned",
    title: "Indian Soldiers at Thermopylae",
    date: "15 Nov 2025",
    description:
      "The presence of Indian troops at Thermopylae highlights that the history of early Indo-European interaction is deeper and more interconnected than commonly assumed.",
  },
];

export default posts;
